// filepath: c:\Code\Standards-Australia\Sa.ConnectPortal\Sa.Connect.UI\src\app\core\controls\directives\plain-tooltip.directive.ts
import { Directive, Input, ElementRef, Renderer2, HostListener, OnDestroy } from '@angular/core';

@Directive({
    selector: '[appTooltip]',
    standalone: false
})
export class TooltipDirective implements OnDestroy {
  @Input('appTooltip') tooltipText: string | null | undefined;
  @Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() delay: number = 200;

  private tooltipElement: HTMLElement | null = null;
  private offset = 10;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnDestroy(): void {
    // Remove tooltip if it exists
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null;
    }
  }

  @HostListener('mouseenter')
  handleMouseEnter() {
    if (!this.tooltipElement) {
      this.showTooltip();
    }
  }

  @HostListener('mouseleave')
  handleMouseLeave() {
    if (this.tooltipElement) {
      this.hideTooltip();
    }
  }

  private showTooltip() {
    if (!this.tooltipText) return;
    
    this.tooltipElement = this.renderer.createElement('span');
    this.renderer.appendChild(
      this.tooltipElement,
      this.renderer.createText(this.tooltipText)
    );
    this.renderer.appendChild(document.body, this.tooltipElement);

    this.renderer.addClass(this.tooltipElement, 'plain-tooltip');
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'pointer-events', 'none');
    this.setTooltipPosition();

    setTimeout(() => {
      if (this.tooltipElement) {
        this.renderer.addClass(this.tooltipElement, 'tooltip-show');
      }
    });
  }

  private hideTooltip() {
    if (!this.tooltipElement) return;
    this.renderer.removeClass(this.tooltipElement, 'tooltip-show');
    setTimeout(() => {
      if (this.tooltipElement) {
        this.renderer.removeChild(document.body, this.tooltipElement);
        this.tooltipElement = null;
      }
    }, this.delay);
  }

  private setTooltipPosition() {
    if (!this.tooltipElement) return;
    const hostRect = this.el.nativeElement.getBoundingClientRect();
    const tooltipRect = this.tooltipElement.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;

    let top = 0, left = 0;

    switch (this.placement) {
      case 'top':
        top = hostRect.top - tooltipRect.height - this.offset;
        left = hostRect.left + (hostRect.width - tooltipRect.width) / 2;
        break;
      case 'bottom':
        top = hostRect.bottom + this.offset;
        left = hostRect.left + (hostRect.width - tooltipRect.width) / 2;
        break;
      case 'left':
        top = hostRect.top + (hostRect.height - tooltipRect.height) / 2;
        left = hostRect.left - tooltipRect.width - this.offset;
        break;
      case 'right':
        top = hostRect.top + (hostRect.height - tooltipRect.height) / 2;
        left = hostRect.right + this.offset;
        break;
    }

    this.renderer.setStyle(this.tooltipElement, 'top', `${top + scrollY}px`);
    this.renderer.setStyle(this.tooltipElement, 'left', `${left + scrollX}px`);
    this.renderer.setStyle(this.tooltipElement, 'z-index', '1000');
  }
}